// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__a3mib","label":"styles_label__y6j9j","subtitle":"styles_subtitle__4x4OH"};